import * as sdk from "microsoft-cognitiveservices-speech-sdk";

//BbQZ8WGGKQOuy6UCRxA4BW8Kzgx0BYa7LyVwmgeGS4EmvCv6lEqhJQQJ99BAACi0881XJ3w3AAAYACOGaOi7
//BznIFIXStqW9RwzXmGx0VlwJCzYEPX35wtUWVev4M26mIPUJD4NDJQQJ99BAACi0881XJ3w3AAAYACOGPENy
// Speech 服務配置
const SPEECH_CONFIG = {
    key: 'BbQZ8WGGKQOuy6UCRxA4BW8Kzgx0BYa7LyVwmgeGS4EmvCv6lEqhJQQJ99BAACi0881XJ3w3AAAYACOGaOi7',
    region: 'japaneast'
};

// 添加一個全局的 synthesizer 實例
let currentSynthesizer = null;

// 添加一個全局的音頻源變量
let currentAudioSource = null;
let currentAudioContext = null;

function cleanupCurrentAudio(closeContext = true) {
    if (currentAudioSource) {
        try {
            currentAudioSource.onended = null;
            currentAudioSource.stop();
        } catch (error) {
            // 忽略已停止或尚未開始播放的音源錯誤
        }

        try {
            currentAudioSource.disconnect();
        } catch (error) {
            // 忽略斷開音源時的錯誤
        }

        currentAudioSource = null;
    }

    if (closeContext && currentAudioContext) {
        try {
            currentAudioContext.close();
        } catch (error) {
            // 忽略重複關閉 AudioContext 的錯誤
        }

        currentAudioContext = null;
    }
}

// Speech 服務工具類
export const speechService = {
    currentRecognizer: null,

    // 文字轉語音
    textToSpeech: async (text, language = 'zh-TW', onCompleted = null) => {
        try {
            // 如果有正在進行的播放，先停止它
            if (currentSynthesizer) {
                currentSynthesizer.close();
                currentSynthesizer = null;
            }

            cleanupCurrentAudio();

            const config = sdk.SpeechConfig.fromSubscription(
                SPEECH_CONFIG.key,
                SPEECH_CONFIG.region
            );
            config.speechSynthesisLanguage = language;
            
            // 設置語速（可選：0.5-2.0）
            config.speechSynthesisRate = 1.5;  // 默認速度，可以根據需要調整
            
            // 設置神經網絡語音
            const voiceMap = {
                'zh-TW': 'zh-TW-HsiaoChenNeural',
                'zh-CN': 'zh-CN-XiaoxiaoNeural',
                'ja-JP': 'ja-JP-NanamiNeural',
                'ko-KR': 'ko-KR-SunHiNeural',
                'th-TH': 'th-TH-PremwadeeNeural',
                'id-ID': 'id-ID-GadisNeural',
                'es-ES': 'es-ES-ElviraNeural',
                'en-US': 'en-US-JennyNeural',
                'de-DE': 'de-DE-KatjaNeural',
                'fr-FR': 'fr-FR-DeniseNeural',
                'it-IT': 'it-IT-ElsaNeural',
            };
            const voiceName = voiceMap[language] || 'en-US-JennyNeural';
            config.speechSynthesisVoiceName = voiceName;

            // 創建 synthesizer，不指定音頻輸出
            const synthesizer = new sdk.SpeechSynthesizer(config, null);
            currentSynthesizer = synthesizer;

            // 創建 AudioContext
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            currentAudioContext = audioContext;

            return new Promise((resolve, reject) => {
                synthesizer.speakTextAsync(
                    text,
                    result => {
                        if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
                            const audioData = result.audioData;
                            const arrayBuffer = new Uint8Array(audioData).buffer;

                            audioContext.decodeAudioData(arrayBuffer).then(decodedData => {
                                const audioSource = audioContext.createBufferSource();
                                audioSource.buffer = decodedData;
                                audioSource.connect(audioContext.destination);
                                currentAudioSource = audioSource;

                                audioSource.onended = () => {
                                    cleanupCurrentAudio();

                                    if (onCompleted && typeof onCompleted === 'function') {
                                        onCompleted();
                                    }

                                    resolve({ result, completed: true });
                                };

                                audioSource.start();
                            }).catch(error => {
                                cleanupCurrentAudio();
                                reject(error);
                            });
                        } else {
                            cleanupCurrentAudio();
                            reject(new Error(result.errorDetails));
                        }
                        synthesizer.close();
                        currentSynthesizer = null;
                    },
                    error => {
                        // console.error("語音合成錯誤: ", error);
                        synthesizer.close();
                        currentSynthesizer = null;
                        cleanupCurrentAudio();
                        reject(error);
                    }
                );
            });
        } catch (error) {
            // console.error('文字轉語音失敗:', error);
            throw error;
        }
    },

    // 修改停止播放方法
    stopSpeaking: () => {
        if (currentSynthesizer) {
            currentSynthesizer.close();
            currentSynthesizer = null;
        }

        cleanupCurrentAudio();
    },

    // 語音轉文字
    speechToText: async (language = 'zh-TW', onTranscribed = null) => {
        try {
            // 如果已經有正在運行的識別器，先停止它
            if (speechService.currentRecognizer) {
                speechService.stopSpeechToText();
            }

            // 創建新的配置
            const speechConfig = sdk.SpeechConfig.fromSubscription(
                SPEECH_CONFIG.key,
                SPEECH_CONFIG.region
            );
            speechConfig.speechRecognitionLanguage = language;

            // 檢查麥克風權限
            try {
                await navigator.mediaDevices.getUserMedia({ audio: true });
            } catch (error) {
                throw new Error('麥克風權限被拒絕');
            }

            // 創建音頻配置
            const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
            
            // 創建識別器
            const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
            speechService.currentRecognizer = recognizer;

            // 設置事件處理
            recognizer.recognized = (s, e) => {
                if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
                    const text = e.result.text;
                    if (onTranscribed && text) {
                        onTranscribed(text);
                    }
                }
            };

            recognizer.recognizing = (s, e) => {
                // 可選：處理中間結果
                console.log('識別中...', e.result.text);
            };

            recognizer.canceled = (s, e) => {
                console.log('識別取消:', e.errorDetails);
                speechService.stopSpeechToText();
            };

            // 開始識別
            return new Promise((resolve, reject) => {
                recognizer.startContinuousRecognitionAsync(
                    () => resolve(),
                    (error) => reject(error)
                );
            });

        } catch (error) {
            console.error('語音識別初始化錯誤:', error);
            throw error;
        }
    },

    // 添加停止識別方法
    stopSpeechToText: () => {
        if (speechService.currentRecognizer) {
            speechService.currentRecognizer.stopContinuousRecognitionAsync(
                () => {
                    console.log("停止語音識別");
                    speechService.currentRecognizer.close();
                    speechService.currentRecognizer = null;
                },
                (err) => console.error("停止識別時發生錯誤:", err)
            );
        }
    },

    // 停用遙測數據收集
    disableTelemetry: () => {
        sdk.Recognizer.enableTelemetry(false)
    }
}

// 錯誤處理
export const handleSpeechError = (error) => {
    console.error('Speech 服務錯誤:', error)
    return {
        error: '語音服務發生錯誤',
        details: error.message
    }
} 
